import useSWR from "swr";
import {LiveSessionInfoDto} from "../../../services/api";

export const useLiveSessionInfo = (condition: boolean) => {
    const key = `/api/exchange-sessions/liveSessionInfo`;
    const {data, isLoading, error} = useSWR<LiveSessionInfoDto, Error>(condition ? key : null);

    return {
        mutationKey: key,
        data: data,
        isLoading,
        error
    }
}
